export default class Tracking {
    constructor() {
        window.dataLayer = window.dataLayer || [];
        this.init();
    };

    get browserId() {
        let browserId = '';
        let json = Cookies.get('_pcid');
        if (json) {
            let data = JSON.parse(decodeURI(json));
            browserId = data['browserId'] ?? '';
        }
        return browserId;
    }
    
    init() {
        const customLayer = document.querySelectorAll('[data-layer]');
        
        if(customLayer) {
            customLayer.forEach(element => {
                element.addEventListener('click', event => {
                    event.preventDefault();
                    switch (element.dataset.layer) {
                        case 'paypalexpress': this.PaypalExpress(); break;
                        default: this.GenericClick(element);
                    }
                    window.open(event.currentTarget.getAttribute('href'));
                });
            });
        }
    }

    push(data) {
        window.dataLayer.push(data);
    };

    customEvent(eventName, payload, eventType) {
        if(typeof eventType === "undefined")
            eventType = "gaEvent";

        let data = {
            'event' : eventType,
            'event_name' : eventName,
        };
        data[eventName] = payload;
        window.dataLayer.push(data);
    };

    GenericClick(element) {
        let layername = (element.dataset.layername) ? element.dataset.layername : 'click';
        
        let event = {
            'event' : 'gaEvent',
            'event_name' : layername
        };
        
        event[layername] = {
            event_category: (element.dataset.layercategory) ? element.dataset.layercategory : 'click',
            event_action: (element.dataset.layeraction) ? element.dataset.layeraction : 'click',
            event_label: (element.dataset.layerlabel) ? element.dataset.layerlabel : element.getAttribute('href'),
        }

        window.dataLayer.push(event);
    }

    PaypalExpress() {
        let event = {
            'event' : 'gaEvent',
            'event_name' : 'checkout_paypal',
            'gtm.uniqueEventId' : 3512,
            'checkout_paypal' : {
                product_name: Landingpage.offer.title,
                event_category: 'checkout',
                event_action: 'paypal',
                event_label: Landingpage.offer.title,
                step: 1,
                maxStep: parseInt(Landingpage.maxSteps)
            }
        };
        window.dataLayer.push(event);
    };
}
